import { atom } from "jotai";

export const onboardingDataAsyncAtom = atom(async () => {
  const response = await fetch("/api/canvasui/onboarding", {
    method: "GET",
    headers: {
      accept: "application/json",
    },
  });

  if (!response.ok) {
    throw new Error(`Error: ${response.status}`);
  }

  return await response.json();
});

onboardingDataAsyncAtom.debugLabel = "onboardingDataAsyncAtom";
